import Availability from "Components/Availability";
import { useGebruikerContext } from "../../Context/GebruikerContext";

const Beschikbaarheid = () => {
	const { currentUser, setActiveTab, userTabs } = useGebruikerContext();

	const handleNavigation = () => {
		setActiveTab(userTabs.Functies)
	}
	return (
		<Availability>
			<Availability.Container>
				<Availability.Table iAdminId={currentUser?.data?.clooserId} isCoord={true} />
			</Availability.Container>
			<Availability.Footer handleBackClick={handleNavigation} />
			<Availability.Modals iAdminId={currentUser?.data?.clooserId} />
		</Availability>
	);
};

export default Beschikbaarheid;
